import apiService from '@/utils/api-client'
import config from "@/utils/appConfig";
import { isOwnOrganizationScope } from '@/utils/organization-scope'

export default {
	// eslint-disable-next-line no-unused-vars
  getUsersList(
    _,
    {
      count,
      skip,
      email,
      companyName,
      category,
      roleId,
      sortField = 'createdAt',
      sortOrder = -1,
    } = {},
  ) {
    return apiService.get('admin/users-list', {
      params: {
        count,
        skip,
        email,
        companyName,
        category,
        roleId,
        sortField,
        sortOrder,
      },
      baseURL: config.VUE_APP_API_USERS_URL,
    })
  },
  // eslint-disable-next-line no-unused-vars
  getOrganizationUsersList(
    _,
    {
      organizationId,
      count,
      skip,
      email,
      category,
      roleId,
      sortField = 'createdAt',
      sortOrder = -1,
    } = {},
  ) {
    if (!organizationId) {
      return Promise.resolve({ data: { items: [], totalItems: 0 } })
    }

    return apiService.get(`organization/${organizationId}/users`, {
      params: {
        count,
        skip,
        email,
        category,
        roleId,
        sortField,
        sortOrder,
      },
      baseURL: config.VUE_APP_API_USERS_URL,
    })
  },
  // eslint-disable-next-line no-unused-vars
  getUsersStatistics({ commit }, { id, startAt, endAt = +new Date(), tags = ["NEW_TRANSACTION", "REPORT_GET", "MONITORING_ADD", "SANKEY_REPORT_CREATE", "DEFI_REPORT_CREATE", "ATC_REPORT_CREATE", "AI_REPORT_TRANSACTION_ASSESS"] }) {
    if (startAt) {
      const startAtDate = new Date(startAt);
      startAtDate.setHours(0, 0, 0, 0);
      startAt = startAtDate.getTime();
    }

    const endAtDate = new Date(endAt);
    endAtDate.setHours(23, 59, 59, 999);
    endAt = endAtDate.getTime();

    return apiService.get(`admin/users/${id}/usage-statistics`, { params: { startAt, endAt: !startAt ? undefined : endAt, tags }, baseURL: config.VUE_APP_API_USERS_URL })
  },
  // eslint-disable-next-line no-unused-vars
  setActiveUser({ commit }, data) {
    return apiService.put('admin/set-active-status', data, { baseURL: config.VUE_APP_API_USERS_URL })
  },
  // eslint-disable-next-line no-unused-vars
  getUser({ commit }, id) {
    return apiService.get(`admin/users/${id}`, { baseURL: config.VUE_APP_API_USERS_URL })
  },
  // eslint-disable-next-line no-unused-vars
  getUserActivityList({ rootGetters }, { id, sortField, sortOrder, count = 10, skip = 0 }) {
    const endpoint = isOwnOrganizationScope(rootGetters['user/permissions'])
      ? `organization/customers/${id}/activity-logs`
      : `admin/users/${id}/activity-logs`
    return apiService.get(endpoint, { params: { count, skip, sortOrder, sortField },  baseURL: config.VUE_APP_API_USERS_URL })
  },
  getOrganizationActivityLogs(
    { rootGetters },
    { organizationId, sortField, sortOrder, count, skip = 0 } = {},
  ) {
    const endpoint = isOwnOrganizationScope(rootGetters['user/permissions'])
      ? 'organization/customers/activity-logs'
      : `organization/${organizationId}/activity-logs`

    return apiService.get(endpoint, {
      params: { count, skip, sortOrder, sortField },
      baseURL: config.VUE_APP_API_USERS_URL,
    })
  },
  editUser({ rootGetters }, { id, body }) {
    const endpoint = isOwnOrganizationScope(rootGetters['user/permissions'])
      ? `organization/customers/${id}`
      : `admin/users/${id}`
    return apiService.patch(endpoint, body, { baseURL: config.VUE_APP_API_USERS_URL })
  },
  deleteUser(ctx, id) {
    return apiService.delete(`admin/users/${id}`, { baseURL: config.VUE_APP_API_USERS_URL })
  },
	// eslint-disable-next-line no-unused-vars
	sendInviteUser({ commit }, { email, role, organizationId, roleIds }) {
    const body = {
      email,
      siteUrl: window.location.origin,
    }

    if (role) body.role = role
    if (Array.isArray(roleIds) && roleIds.length) body.roleIds = roleIds
    if (organizationId) body.organizationId = organizationId

    return apiService.post('admin/send-invitation', body, { baseURL: config.VUE_APP_API_USERS_URL })
  },
	// eslint-disable-next-line no-unused-vars
	resetPassword({ commit }, email) {
    return apiService.get(`users/reset-password/${email}`, { params: { siteUrl: window.location.origin }, baseURL: config.VUE_APP_API_USERS_URL })
  },
  // organization users
  getOrganizationsList({ commit }) {
    return apiService.get('admin/organization-list', { baseURL: config.VUE_APP_API_USERS_URL })
    .then((data) => {
      commit('SET_LIST_ORGANIZATIONS', data)
    })
    .catch((error) => {
      throw error
    })
  },
  // eslint-disable-next-line no-unused-vars
  sendInviteOrgUser({ commit }, email) {
    return apiService.post('organization/customers/invite', { email }, { baseURL: config.VUE_APP_API_USERS_URL })
  },
  // eslint-disable-next-line no-unused-vars
  setActiveOrgUser({ commit }, data) {
    return apiService.patch(`organization/customers/${data.id}`, data, { baseURL: config.VUE_APP_API_USERS_URL })
  },
  // eslint-disable-next-line no-unused-vars
  getOrganizationList(
    _,
    {
      skip = 0,
      limit = 20,
      disabled,
      name,
      category,
      sortField = 'createdAt',
      sortOrder = -1,
    } = {},
  ) {
    const params = { skip, limit, sortField, sortOrder }

    if (typeof disabled === 'boolean') params.disabled = disabled
    if (name) params.name = name
    if (category) params.category = category

    return apiService.get('organization', {
      params,
      baseURL: config.VUE_APP_API_USERS_URL,
    })
  },
  // eslint-disable-next-line no-unused-vars
  setOrganizationDisabled({ commit }, { id, disabled }) {
    return apiService.post(`organization/${id}/set-disabled`, { disabled }, {
      baseURL: config.VUE_APP_API_USERS_URL,
    })
  },
  // eslint-disable-next-line no-unused-vars
  getOrganizationCategoryOptions({ commit }) {
    return apiService.get('organization/category', {
      baseURL: config.VUE_APP_API_USERS_URL,
    })
  },
  // Silent duplicate-name check for the Add Organization modal (GLBA-13245).
  // Resolves to { status: 'ok' | 'exists' | 'similar' } — deliberately no names,
  // ids or scores, so the endpoint can't be used to enumerate organization names.
  // Body schema is `additionalProperties: false` with name (3–150 chars) and an
  // optional excludeOrganizationId (rename only — unused while this is create-only),
  // so nothing beyond those keys may be sent.
  // eslint-disable-next-line no-unused-vars
  checkOrganizationName({ commit }, { name, excludeOrganizationId, cancelToken } = {}) {
    const body = { name }

    if (excludeOrganizationId) body.excludeOrganizationId = excludeOrganizationId

    return apiService.post('organization/check-name', body, {
      cancelToken,
      baseURL: config.VUE_APP_API_USERS_URL,
    })
  },
  // eslint-disable-next-line no-unused-vars
  createOrganization({ commit }, body) {
    return apiService.post('organization', body, {
      baseURL: config.VUE_APP_API_USERS_URL,
    })
  },
  // eslint-disable-next-line no-unused-vars
  getOrganizationById({ commit }, id) {
    return apiService.get(`organization/${id}`, {
      baseURL: config.VUE_APP_API_USERS_URL,
    })
  },
  // eslint-disable-next-line no-unused-vars
  updateOrganizationById({ commit }, { id, body }) {
    return apiService.patch(`organization/${id}`, body, {
      baseURL: config.VUE_APP_API_USERS_URL,
    })
  },
  // eslint-disable-next-line no-unused-vars
  updateOrgAdminOrganization({ commit }, { body }) {
    return apiService.patch('organization/customers', body, {
      baseURL: config.VUE_APP_API_USERS_URL,
    })
  },
  // eslint-disable-next-line no-unused-vars
  resetOrgUserPassword({ commit }, email) {
    return apiService.get(`organization/customers/reset-password/${email}`, { params: { siteUrl: window.location.origin }, baseURL: config.VUE_APP_API_USERS_URL })
  },
  // eslint-disable-next-line no-unused-vars
  getOrgUserInfo({ commit }, id) {
    return apiService.get(`organization/customers/${id}`, { baseURL: config.VUE_APP_API_USERS_URL })
  },
}
